"use client";

import { useEffect, useState, useRef } from "react";
import { io, Socket } from "socket.io-client";
import { useAuth } from "../context/AuthContext";
//import BidModal from "@/components/BidModal";

type Lot = {
  id: number;
  lot_number: string;
  title: string;
  status: string;
  current_price: number;
  increment: number;

  current_winner?: string | null;

  internet_deadline?: string | null;
  internet_dispute?: boolean;
  server_now?: string;
};

type Bid = {
  value: number;
  bidder_name: string;
  is_robot: boolean;
};

type Media = {
  id: number;
  type: "image" | "video";
  url: string;
};

type Robot = {
  lot_id: number;
  lot_number: string;
  current_price: number;
  max_bid: number;
  current_winner: string;
};

type Props = {
  lot: Lot | null;
  onClose: () => void;
};

function formatarMoeda(valor: number) {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export default function BidModal({ lot, onClose }: Props) {
  const { token, nickname } = useAuth();

  const [lotState, setLotState] = useState<Lot | null>(null);
  const [bids, setBids] = useState<Bid[]>([]);
  const [media, setMedia] = useState<Media[]>([]);
  const [meusRobos, setMeusRobos] = useState<Robot[]>([]);
  const [livestreamUrl, setLivestreamUrl] = useState<string | null>(null);

  const [maxRobotBid, setMaxRobotBid] = useState("");
  const [maxRobotBidNumber, setMaxRobotBidNumber] = useState<number | null>(null);

  const [isBidding, setIsBidding] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [highlightPrice, setHighlightPrice] = useState(false);
  
  const [serverOffset,setServerOffset] = useState(0)

  const beepRef = useRef<HTMLAudioElement | null>(null)

  const socketRef = useRef<Socket | null>(null);
  const [now,setNow] = useState(Date.now())

  /* ================= BEEP ================= */
      useEffect(()=>{

      beepRef.current = new Audio("/sounds/beep.mp3")

    },[])
    
  /* ================= FIM BEEP ================= */

  /* ================= SINCRONIZA TIMER ================= */
  useEffect(()=>{

    const timer = setInterval(()=>{
      setNow(Date.now())
    },1000)

    return ()=>clearInterval(timer)

  },[])
  /* ================= FIM - SINCRONIZA TIMER ================= */

  /* ================= SINCRONIZA LOTE ================= */
useEffect(() => {
  setLotState(lot);
}, [lot]);
  /* ================= FIM - SINCRONIZA LOTE ================= */

/* ================= LOAD INICIAL DO MODAL ================= */

useEffect(() => {

  if (!lot) return;

  carregarLoteAtual()

  carregarBids();
  carregarMedia();
  carregarRobos();
  carregarTransmissao();
  carregarConfiguracaoRobo();

}, [lot?.id]);


//useEffect(() => {

//  if (!lotState) return;

//  carregarLoteAtual()   // 👈 ESTA LINHA FALTAVA

//  carregarBids();
//  carregarMedia();
//  carregarRobos();
//  carregarTransmissao();
//  carregarConfiguracaoRobo();

// }, [lotState?.id]);

/* ================= SINCRONIZA RELÓGIO DO SERVIDOR ================= */
useEffect(()=>{

  if(!lotState?.server_now) return

  const serverTime = new Date(lotState.server_now).getTime()
  const localTime = Date.now()

  setServerOffset(serverTime - localTime)

},[lotState?.server_now])

/* ================= FIM ================= */

/* =============== FIM - LOAD INICIAL DO MODAL ================= */

    const previousPriceRef = useRef<number | null>(null);

useEffect(() => {
  if (!lotState) return;

  if (
    previousPriceRef.current !== null &&
    previousPriceRef.current !== lotState.current_price
  ) {
    setHighlightPrice(true);

    const timer = setTimeout(() => {
      setHighlightPrice(false);
    }, 600);

    return () => clearTimeout(timer);
  }

  previousPriceRef.current = lotState.current_price;
}, [lotState?.current_price]);
/* ============================================================== */
  /* ================= STATUS ================= */

  function traduzStatus(status: string) {

  if (status === "RECEBENDO_LANCES") return <span style={{ color:"#33353f", fontWeight:600 }}>🙋🏻‍♂️ Recebendo Lances</span>;

  if (status === "EM_LEILAO") return <span style={{ color:"#050381", fontWeight:600 }}>🪒 EM LEILÃO</span>;

  if (status === "DISPUTA_INTERNET") return <span style={{ color:"#dc2626", fontWeight:600 }}>⏱ Disputa Internet</span>;
  
  if (status === "DISPUTA_ENCERRADA") return <span style={{ color:"#2e0336", fontWeight:600 }}>🔚 Disputa Finalizada</span>;

  if (status === "VENDIDO") return "Vendido";

  if (status === "CONDICIONAL") return "Condicional";

  if (status === "RECUSADO") return "Venda Recusada";

  if (status === "RETIRADO") return "Retirado";

  return status;
}
   /* ================= FIM STATUS ================= */

  /* ================= LOADERS ================= */

  async function carregarLoteAtual() {

  if (!lotState) return;

  const res = await fetch(
    `https://api.nexbid.pro/lot/${lotState.id}`
  );

  const data = await res.json();

  if (data?.id) {

    setLotState(data);

    if(data.server_now){

      const serverTime = new Date(data.server_now).getTime()
      const localTime = Date.now()

      setServerOffset(serverTime - localTime)

    }

  }

}
  
  async function carregarBids() {
    if (!lotState) return;

    const res = await fetch(
      `https://api.nexbid.pro/lot/${lotState.id}/bids`
    );

    const data = await res.json();
    if (Array.isArray(data)) setBids(data);
  }

  async function carregarMedia() {
    if (!lotState) return;

    const res = await fetch(
      `https://api.nexbid.pro/lot/${lotState.id}/media`
    );

    const data = await res.json();
    if (Array.isArray(data)) setMedia(data);
  }

  async function carregarRobos() {
    if (!token) return;

    const res = await fetch(
      `https://api.nexbid.pro/robots/my`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const data = await res.json();
    if (Array.isArray(data)) setMeusRobos(data);
  }

  async function carregarTransmissao() {
    const res = await fetch(
      `https://api.nexbid.pro/auction/livestream`
    );

    const data = await res.json();
    setLivestreamUrl(data?.livestream_url || null);
  }

  /* ========== Carregar Configruração do Robô ===============*/
    async function carregarConfiguracaoRobo() {
  if (!token || !lotState) return;

  const res = await fetch(
    `https://api.nexbid.pro/robot/config/${lotState.id}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  const data = await res.json();

  if (data?.max_bid) {
    const valor = Number(data.max_bid);
    setMaxRobotBidNumber(valor);
    setMaxRobotBid(formatarMoeda(valor));
  } else {
    setMaxRobotBid("");
    setMaxRobotBidNumber(null);
  }
}
/* ========== FIM - Carregar Configruração do Robô ===============*/

  /* ================= SOCKET ================= */

useEffect(() => {

  if (!lot) return;

  socketRef.current = io("https://api.nexbid.pro", {
  transports: ["polling", "websocket"],
  withCredentials: true
});

  const socket = socketRef.current;

  socket.on("lot:update", (data) => {

    if (!data || !data.lot_id) return;

    /* atualiza lote aberto no modal */
    setLotState((prev) => {

      if (!prev) return prev;
      if (prev.id !== data.lot_id) return prev;

      return {
        ...prev,

        current_price:
          data.current_price !== undefined
            ? data.current_price
            : prev.current_price,

        status:
          data.status !== undefined
            ? data.status
            : prev.status,

          current_winner:
            data.current_winner !== undefined
              ? data.current_winner
              : prev.current_winner,

        internet_deadline:
          data.internet_deadline !== undefined
            ? data.internet_deadline
            : prev.internet_deadline,

        internet_dispute:
          data.internet_dispute !== undefined
            ? data.internet_dispute
            : prev.internet_dispute

      };

    });

/* Beep Lances */    
    if(data?.current_price){

      if(beepRef.current){
        beepRef.current.currentTime = 0
        beepRef.current.play().catch(()=>{})
      }

    }
/* FIM - Beep Lances */

    /* atualiza robôs da lista */
    setMeusRobos((prev) =>
      prev.map((r) =>
        r.lot_id === data.lot_id
          ? {
              ...r,
              current_price: data.current_price,
              current_winner: data.current_winner
            }
          : r
      )
    );

  });

  socket.on("bid:update", (data) => {

    if (!data || !data.lot_id) return;

    if (lot && data.lot_id === lot.id) {
      setBids(data.bids || []);
    }

    /* atualiza lista de robôs */
    carregarRobos();

  });

  return () => {
    socket.disconnect();
  };

}, [lot]);

/* ============= FIM - SOCKET =========== */

  /* ============= FUNÇÃO DARLANCE() =========== */

        function darLance(times: number = 1) {

       /* if (!socketRef.current || !lotState || !token) return; */
       if (!lotState || !token) return;

        if (!socketRef.current) {
          setErrorMessage("Conectando ao servidor...");
          return;
        }

          console.log("DAR LANCE", {
            socket: socketRef.current,
            lot: lotState?.id,
            token
          });

        /* bloqueia se você já estiver vencendo */

        if (lotState.current_winner === nickname) {
          setErrorMessage("Você já é o maior lance.");
          return;
        }

        /* verifica se lote aceita lance */

        if (
          ![
            "EM_LEILAO",
            "RECEBENDO_LANCES",
            "DISPUTA_INTERNET"
          ].includes(lotState.status)
        ) {
          setErrorMessage("Lote não está recebendo lances.");
          return;
        }

        setErrorMessage(null);
        setIsBidding(true);

        socketRef.current.emit("auction:bid", {
          token,
          lot_id: lotState.id,
          times,
        });

        setTimeout(() => {
          setIsBidding(false);
        }, 800);
      }
  /* ============= FIM - FUNÇÃO DARLANCE() =========== */


  /* ================= PROGRAMAR ROBÔ ================= */

  async function programarRobo() {
  if (!token || !lotState || !maxRobotBidNumber) return;

  const minimo =
    Number(lotState.current_price) +
    Number(lotState.increment);

  if (maxRobotBidNumber <= minimo) {
    alert(
      `O valor do seu Robô deve ser MAIOR que ${formatarMoeda(minimo)}`
    );
    return;
  }

  try {
    const res = await fetch(
      "https://api.nexbid.pro/robot/config",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          lot_id: lotState.id,
          max_bid: maxRobotBidNumber,
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      alert(data.message || data.error || "Erro ao ativar robô.");
      return;
    }

    alert("Robô ativado com sucesso.");

    setMaxRobotBid("");
    setMaxRobotBidNumber(null);

    await carregarRobos();

  } catch (err) {
    console.error("ERRO ROBÔ:", err);
    alert("Erro interno ao ativar robô.");
  }
}
/* ==============FIM - PROGRAMAR ROBÔ ================== */

  if (!lotState) return null;

  const valorMinimo =
    Number(lotState.current_price) +
    Number(lotState.increment);

    let tempoRestante = null

if (lotState.internet_deadline) {

  const diff =
  new Date(lotState.internet_deadline).getTime() - (now + serverOffset)

  tempoRestante = Math.max(0, Math.floor(diff / 1000))

}
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          width: 1100,
          padding: 30,
          borderRadius: 8,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
       <h3>
  Lote {lotState.lot_number} — {traduzStatus(lotState.status)}
</h3>
        {lotState.status === "DISPUTA_INTERNET" && tempoRestante !== null && (

          <div style={{color:"#dc2626", fontWeight:600}}>

            ⏱ Tempo restante:
            {Math.floor(tempoRestante/60)}:
            {(tempoRestante%60).toString().padStart(2,"0")}

          </div>

        )}

        <p>{lotState.title}</p>

        <p>
          Valor Atual:{" "}
          <strong
            style={{
              color: highlightPrice ? "#16a34a" : "#000",
              transition: "0.3s",
              fontSize: highlightPrice ? 22 : 20,
            }}
          >
            {formatarMoeda(lotState.current_price)}
          </strong>
        </p>

        {/* BOTÕES DE LANCE */}
        <div style={{ display: "flex", gap: 10 }}>
        <button onClick={() => darLance(1)}>
        {/* <button disabled={isBidding} onClick={() => darLance(1)}> */}
        {isBidding ? "Enviando..." : `+${formatarMoeda(lotState.increment)}`}
        </button>

        <button disabled={isBidding} onClick={() => darLance(2)}>
          +{formatarMoeda(lotState.increment * 2)}
        </button>

        <button disabled={isBidding} onClick={() => darLance(3)}>
          +{formatarMoeda(lotState.increment * 3)}
        </button>
        </div>

        {errorMessage && (
          <div
            style={{
              marginTop: 10,
              padding: 8,
              background: "#fee2e2",
              color: "#991b1b",
              borderRadius: 6,
              fontSize: 14,
            }}
          >
            {errorMessage}
          </div>
        )}

        <hr />

        {/* HISTÓRICO */}
        <h3>Últimos Lances</h3>
        {bids.map((b, i) => (
          <div
            key={i}
            style={{
              background: i === 0 ? "#d4f5d4" : "transparent",
              padding: 6,
            }}
          >
            {b.is_robot ? "🤖 " : ""}
            {b.bidder_name} — {formatarMoeda(b.value)}
            {i === 0 && <span> (Maior Lance)</span>}
          </div>
        ))}

        <hr />

        {/* MÍDIA */}
        <h3>Fotos / Vídeos</h3>
        {media.length === 0 && <p>Sem mídia cadastrada.</p>}
        {media.map((m) =>
          m.type === "image" ? (
            <img
              key={m.id}
              src={m.url}
              style={{ width: "100%", marginBottom: 10 }}
            />
          ) : (
            <video
              key={m.id}
              src={m.url}
              controls
              style={{ width: "100%", marginBottom: 10 }}
            />
          )
        )}

        <hr />

        {/* TRANSMISSÃO */}
        <h3>Transmissão</h3>
        {livestreamUrl ? (
          <iframe
            src={livestreamUrl}
            style={{ width: "100%", height: 300 }}
          />
        ) : (
          <p>Transmissão não disponível.</p>
        )}

        <hr />

        {/* ROBÔ */}
        <h3>Programar Robô</h3>

        <input
          type="text"
          value={maxRobotBid}
          placeholder="Digite o valor máximo"
          onChange={(e) => {
            const onlyNumbers = e.target.value.replace(/\D/g, "");
            const number = Number(onlyNumbers) / 100;

            setMaxRobotBidNumber(number || null);
            setMaxRobotBid(
              onlyNumbers ? formatarMoeda(number) : ""
            );
          }}
          style={{ marginRight: 10 }}
        />

        <button
          onClick={programarRobo}
          disabled={
            !maxRobotBidNumber ||
            maxRobotBidNumber <= valorMinimo
          }
        >
          Ativar Robô
        </button>
          <p style={{ color: "red", fontSize: 12 }}>
                O valor do robô não pode ser alterado após ativação.
            </p>
          <p style={{ fontSize: 12, marginTop: 6 }}>
          ⚠ O valor máximo deve ser acima de{" "}
          {formatarMoeda(valorMinimo)}
        </p>

        {maxRobotBidNumber && (
          <p style={{ fontSize: 12 }}>
            Seu robô está programado até{" "}
            {formatarMoeda(maxRobotBidNumber)}
          </p>
        )}

        <hr />

        {/* MEUS ROBÔS */}
        <h3>Meus Robôs</h3>

        {meusRobos.length === 0 && (
          <p style={{ fontSize: 12 }}>Nenhum robô ativo.</p>
        )}

        {meusRobos.map((r, i) => {
          const vencendo = r.current_winner === nickname;

          return (
            <div key={r.lot_id} style={{ marginBottom: 6, fontSize: 12 }}>
              Lote {r.lot_number} | Atual:{" "}
              {formatarMoeda(r.current_price)} | Meu Robô:{" "}
              {formatarMoeda(r.max_bid)} | Vencedor:{" "}
              {r.current_winner || "—"}{" "}
              {vencendo ? (
                "✔ Vencendo"
              ) : (
                <button
                  disabled={isBidding}
                  onClick={() => {

                    if (!socketRef.current) return;

                    setIsBidding(true);

                    socketRef.current.emit("auction:bid", {
                      token,
                      lot_id: r.lot_id,
                      times: 1
                    });

                    setTimeout(() => {
                      setIsBidding(false);
                    }, 700);

                  }}
                >
                  Dar Lance
                </button>
              )}
            </div>
          );
        })}

        <hr />

        <button onClick={onClose}>Fechar</button>
      </div>
    </div>
  );
}
